import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import '../../components/SearchResult/SearchResult.css';

const SearchResult = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const results = location.state?.results?.categories || [];
	const keyword = location.state?.keyword || '';

	const handleItemClick = (item) => {
		navigate(`/categories/${item.url}`);
	};

	return (
		<div className="search-result-wrapper font-poppins">
			<div className="search-result-header">
				<h2>Search Results for: <span>"{keyword || 'All Categories'}"</span></h2>
			</div>

			{results.length > 0 ? (
				<div className="search-result-grid">
					{results.map((item) => (
						<div
							key={item.id}
							className="search-card"
							onClick={() => handleItemClick(item)}
						>
							<div className="search-card-content">
								<h3>{item.name}</h3>
							</div>
						</div>
					))}
				</div>
			) : (
				<div className="no-result">No results found.</div>
			)}
		</div>
	);
};

export default SearchResult;